import { ojs, app } from "modular-openscriptjs";
import { disposeBootstrapTree, either } from "../helpers";
import { NavItem, pc } from "../declarations";
import OffcanvasComponent from "./OffcanvasComponent";

const h = app("h");


export default class Navigation extends OffcanvasComponent {
	activeClass = "active";

	dropdownDir() {
		return "dropdown";
	}

	activate(item) {
		return item.pageName === pc.activePage.value
			? { class: "active-nav" }
			: {};
	}

	/**
	 * Parse a nav item
	 * @param {NavItem} item
	 */
	parseItem(item, ...args) {
		if (!item.condition()) return null;

		return h.li(
			{
				class: "nav-item",
				app_hook: "app-nav",
				app_nav_hook: item.appHook,
				onclick: item.onclick,
			},
			h.a(
				{
					class: "d-flex align-items-center gap-2 ",
					role: "button",
					href: "javascript:void(0);",
				},
				h.span({ class: "icon" }, item.icon()),
				h.span({ class: "text" }, item.text),
				either(item.children.length > 0, {
					class: "dropdown-toggle nav-link",
					role: "button",
					data_bs_toggle: "dropdown",
					aria_expanded: "false",
				}),
			),
			either(
				item.children.length > 0 && this.dropdownDir() !== "dropdown",
				{ class: this.dropdownDir() },
			),
			this.dropdown(item.children),
			...args,
		);
	}

	/**
	 *
	 * @param  {NavItem[]} children
	 */
	dropdown(children = []) {
		if (children.length < 1) return [];

		return h.ul(
			{ class: "dropdown-menu" },
			each(children, (item) =>
				this.parseItem(item, { class: "dropdown-item" }),
			),
		);
	}

	/**
	 *
	 * @param {NavItem[]} items
	 */
	renderNav(items) {
		let lis = [];

		for (let nav of items) {
			lis.push(
				this.parseItem(
					nav,
					{ page_name: nav.pageName },
					this.activate(nav),
				),
			);
		}

		return lis;
	}

	filterItems(items, permissions, roles, auth) {
		return items.filter((item) => {
			if (item.auth && !auth.value) return false;
			if (item.guest && auth.value) return false;

			if (item.permission && !permissions.value.includes(item.permission))
				return false;
			if (item.role && !roles.value.includes(item.role)) return false;

			return true;
		});
	}

	cleanUp() {
		super.cleanUp();
		let markup = this.markup();

		for (let elem of markup) {
			disposeBootstrapTree(elem);
		}
	}
}

ojs(Navigation);
